export enum PaymentMethod {
  PayNow = 'pay_now',
  PayLater = 'pay_later',
  PayInParts = 'pay_in_parts',
  PayOverTime = 'pay_over_time',
  CashOnDelivery = 'COD',
  Sberbank = 'Sberbank',
  Adyen = 'Adyen',
  PayPal = 'PayPal',
  Vipps = 'vipps',
  BankTransfer = 'BankTransfer',
  Ideal = '15',
  ApplePay = 'applepay',
  Cybersource = 'CYBERSOURCEAPI',
  MobilePay = 'mobilepay',
  Rupay = 'Rupay',
  Razorpay = 'razorpay',
  RazorpayCard = 'razorpay_card',
  RazorpayEmi = 'razorpay_cardless_emi',
  RazorpayNetbanking = 'razorpay_netbanking',
  RazorpayUpi = 'razorpay_upi',
  RazorpayWallet = 'razorpay_wallet',
  CreditGuard = 'creditguard',
  Afterpay = 'afterpay',
}

export const KLARNA_PAY_LATER_PAYMENT_METHODS: ReadonlyArray<PaymentMethod> = [
  PaymentMethod.PayLater,
  PaymentMethod.PayInParts,
  PaymentMethod.PayOverTime,
]

export const RAZORPAY_SUB_PAYMENT_METHODS: ReadonlyArray<PaymentMethod> = [
  PaymentMethod.RazorpayCard,
  PaymentMethod.RazorpayEmi,
  PaymentMethod.RazorpayNetbanking,
  PaymentMethod.RazorpayUpi,
  PaymentMethod.RazorpayWallet,
]
